__webpack_require__.p = "/reports-dashboard-templates-improvements/referrals-hub/";